import React from 'react';
import ReactDOM from 'react-dom';
import { Filing } from './Filing';
import './styles.css';
import { Router } from 'react-router';
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

function App() {
  return <Filing />;
}

const render = () => (
  <Router history={history}>
    <App />
  </Router>
);

const rootElement = document.getElementById('root');
ReactDOM.render(render(), rootElement);
